/*
 * @Author: Axs <i@axs.email>
 * @Date: 2022-05-05 14:01:48
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-05-05 14:32:43
 * @Description:
 * @FilePath: /src/components/smsVerify/index.js
 */
import util from 'util';
import smsVerify from './index.vue';
import Vue from 'vue';

let el = null;
let time = 0;
let timer = null;
let successFun = null;

const _smsVerify = {
    // smsVerify 打开
    open({ success = null, scene = null } = {}) {
        if (el) {
            return;
        }
        successFun = success;
        let model = Vue.extend(smsVerify);
        let smsVerifyVM = new model();
        smsVerifyVM._time = time;
        smsVerifyVM.scene = scene;
        el = smsVerifyVM.$mount().$el;
        // 插入dom
        document.body.appendChild(el);
        // 清除时间
        if (timer) {
            clearInterval(timer);
        }
    },
    close(_this = null) {
        if (!el) {
            return;
        }
        // 移除dom
        document.body.removeChild(el);
        el = null;
        if (_this) {
            // 同步时间设置
            time = _this.time;
            if (_this.time < 1) {
                return;
            }
            time--;
            timer = setInterval(() => {
                time--;
                if (time < 1) {
                    clearInterval(timer);
                }
            }, 1000);
        }
        util.unlockScreen();
    },
    // 回调触发方法
    callback(options) {
        if (options.success) {
            if (successFun) {
                successFun(options);
            } else {
                this.close();
            }
        }
    },
};

export default _smsVerify;
